import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { none, BookScreen } from './bookScreen';

interface BookState {
  viewModel: BookScreen.ViewModel;
}

const initialState: BookState = {
  viewModel: none(''),
};

export const bookSlice = createSlice({
  name: 'book',
  initialState,
  reducers: {
    setViewModel: (state, action: PayloadAction<BookScreen.ViewModel>) => {
      state.viewModel = action.payload;
    },
  },
});

export const { setViewModel } = bookSlice.actions;

export default bookSlice.reducer;
